import React from 'react';
// Import the local image file
import profileImage from './hemant jha profile pic.png';

// --- PROFILE DATA ---
// This data can be easily updated.
const profileData = {
  name: 'Hemant Jha', // Updated name
  title: 'Founder & Lead Instructor',
  // Use the imported image variable here
  imageUrl: profileImage,
  bio: 'With over 15 years of experience in wellness, my mission is to empower you to find balance and joy through mindful practices. Join our community and start your journey today.',
  attributes: [
    { title: 'Innovator', description: 'Pioneering new techniques in mindfulness and digital wellness solutions.' },
    { title: 'Researcher', description: 'Focused on evidence-based practices to manage complex mental and physical systems.' },
    { title: 'Trainer', description: 'Conducted 200+ workshops on product engineering, design, and personal growth.' },
    { title: 'Marathoner', description: 'A long-distance runner completely addicted to the discipline and reward of marathon running.' },
    { title: 'Designer', description: 'Specializing in designing systems and user experiences for the last 25 years.' },
  ]
};

const Profile = () => {
  return (
    <div className="profile-page">
      <div className="profile-header-card">
        <img src={profileData.imageUrl} alt={profileData.name} className="profile-image" />
        <h2 className="profile-name">{profileData.name}</h2>
        <p className="profile-title">{profileData.title}</p>
        <p className="profile-bio">{profileData.bio}</p>
      </div>

      <div className="profile-attributes-list">
        {profileData.attributes.map((attr, index) => (
          <div key={index} className="attribute-card">
            <h3 className="attribute-title">{attr.title}</h3>
            <p className="attribute-description">{attr.description}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Profile;
